import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { mostraAlerta } from "../alerts/sweetAlert";
import { AxiosPublico } from "../../componentes/axios/Axios";
import { UsuarioIniciarSesion } from "../../configuracion/apiUrls";
import { useContextUsuario } from "../../contexto/usuario/UsuarioContext";
import { IdentificarEstacion } from "../../componentes/estacion/Estacion";

const IniciarSesionGoogle = () => {
    // Asegúrate de que este ID de Cliente es el correcto
    const GOOGLE_CLIENT_ID = "195516590670-e1kd3vbfgju73bnlansnqf5juslnkmub.apps.googleusercontent.com";
    return (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <SesionGoogle />
        </GoogleOAuthProvider>
    );
};

const SesionGoogle = () => {
    const navigate = useNavigate();
    const { setLogin } = useContextUsuario();

    const handleGoogleLoginSuccess = async (credentialResponse) => {
        try {
            if (!credentialResponse || !credentialResponse.access_token) {
                throw new Error("Token de Google no recibido");
            }

            const response = await fetch(
                `https://www.googleapis.com/oauth2/v3/userinfo`,
                {
                    headers: {
                        Authorization: `Bearer ${credentialResponse.access_token}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Error al obtener datos del usuario desde Google");
            }

            const userInfo = await response.json();
            const correo = userInfo.email;

            // 1. INTENTAR INICIAR SESIÓN EN EL BACKEND
            try {
                const loginResponse = await AxiosPublico.post(UsuarioIniciarSesion, {
                    login: correo, // Enviamos el correo como el campo de login
                    isGoogleLogin: true,
                });

                const { Usuario: usuario, Token: token } = loginResponse.data;
                console.log("Token de Sesión con Google:", token);
                // Login exitoso
                mostraAlerta(`Bienvenido(a) ${usuario.datoPersonales.nombreCompleto}`, "success");
                await setLogin({ usuario, token });
                await IdentificarEstacion();

                // Lógica de redirección
                if (usuario.tipo === "Cliente") {
                    navigate("/app/clientes/");
                } else if (usuario.tipo === "Empleado") {
                    const accesoActivo = (usuario.accesos || []).find(a => a.estado === "Activo");
                    if (accesoActivo && accesoActivo.ruta) {
                        navigate(accesoActivo.ruta);
                    } else {
                        mostraAlerta("No tiene accesos activos asignados", "warning");
                        navigate("/app/admin/empleados/");
                    }
                } else {
                    navigate("/app/home");
                }

            } catch (loginError) {
                // 2. FALLO DEL LOGIN (Usuario no existe en la DB)

                mostraAlerta(
                    `Bienvenido ${userInfo.given_name}. Usuario no encontrado, por favor, completa tu registro.`,
                    "info"
                );
                // Redirigir al registro con los datos de Google
                navigate("/app/cliente", { state: { googleData: userInfo } });
            }

        } catch (error) {
            console.error("Error al procesar el login con Google:", error);
            mostraAlerta("Error al procesar el inicio de sesión con Google", "error");
        }
    };

    const handleGoogleLoginFailure = () => {
        mostraAlerta("Error al iniciar sesión con Google", "error");
    };

    const googleLogin = useGoogleLogin({
        onSuccess: handleGoogleLoginSuccess,
        onError: handleGoogleLoginFailure,
        flow: "implicit",
    });

    return (
        <button
            type="button"
            className="btn btn-block btn-lg mt-2"
            style={{ backgroundColor: '#DB4437', color: 'white' }}
            onClick={googleLogin}
        >
            <i className="fab fa-google mr-2"></i> Iniciar Sesión con Google
        </button>
    );
};

export default IniciarSesionGoogle;